import { Controller, useFormContext } from 'react-hook-form';
import { TagPicker } from '../components/TagPicker';
import type { SignupFormValues } from '../schema';

export const Step12TagsBusca = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="tagsBuscaIds"
      render={({ field }) => (
        <TagPicker
          category="BUSCA"
          selectedIds={field.value ?? []}
          onChange={field.onChange}
          maxSelections={3}
          errorMessage={errors.tagsBuscaIds?.message}
        />
      )}
    />
  );
};
